import React, { Component } from 'react';
import axios from 'axios'
import { Form, Segment, Button, } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, logComponentLoad } from '../../../../config/constants'
import { checkAdminEmail, getPrintValues } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import Select from 'react-select';



import createBrowserHistory from 'history/createBrowserHistory';
import { getShirtTypeDownDown } from '../LargeProjects/LargeProjectUtils';
const history = createBrowserHistory({ forceRefresh: true });

class EnterShirtTypeToDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            shirtTypeChoices: [],
            displayTypesChoices: [],
            shirtTypeDisplay: '',
            shirtTypeId: '',
            algoliaUser: ''
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;


                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                    //this.getApiDetails();


                }
            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    getAllShirtTypes() {
        console.log("gsh1 ++++++++:getAllShirtTypes");

        axios.post(pythonApiIp + 'getAllShirtTypes', {
            apiKey: "asdf#@dfadda33",
        })
            .then((response) => {

                console.log("gsh12:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                    console.log("gsh13 true.. adding items");
                    this.setState({
                        loading: false,
                        shirtTypeChoices: getShirtTypeDownDown(response.data.shirtTypes)
                    })


                } else {
                    console.log("FAILED");
                    alert("couldn't get shirt types:" + response.data.message);
                    this.setState({
                        loading: false,
                    })
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false,
                })
                alert("couldn't get shirt types:" + error);
            });

    }


    sendShirtTypeToDisplay = () => {
        console.log("++++++++:sendShirtTypeToDisplay");
        console.log("docx3 shirtTypeId Id: " + this.state.shirtTypeId)

        if (this.state.docUrl == '') {
            alert("No docUrl Selected")
        } else if (this.state.shirtTypeId == '') {
            alert("No shirtTypeId Entered")
        } else if (this.state.shirtTypeDisplay == '') {
            alert("No shirtTypeDisplay Entered")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'saveShirtTypeDisplay', {
                apiKey: "asdf^343@",
                shirtTypeId: this.state.shirtTypeId,
                shirtTypeDisplay: this.state.shirtTypeDisplay
            })
                .then((response) => {

                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. sendShirtTypeToDisplay added");

                        //this.resetFeilds();
                        this.setState({ loading: false });
                        alert(response.data.message);

                        // history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false })
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });
        }
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");

        logComponentLoad(returnObject, "EnterShirtTypeToDisplay");

        this.getAllShirtTypes();
        getPrintValues("shirtTypeDisplay", this.loadtypes);

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    loadtypes = (displayTypes) => {
        // console.log("shtx18 ++++++ load display Types ");
        // console.log("shtx18 displayTypes:" + JSON.stringify(displayTypes, null, 3));
        this.setState({ displayTypesChoices: displayTypes })
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        console.log("docx195 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    render() {


        const shirtTypeDropdown = this.state.shirtTypeChoices.length > 0
            ? <Select
                name="form-field-name"
                value={this.state.shirtTypeId}
                options={this.state.shirtTypeChoices}
                onChange={this.handleDropDownChanges}
                searchable={true}
                clearable={false}
            />
            : ''

        const displayTypeDropdown = this.state.displayTypesChoices.length > 0
            ? <Select
                name="form-field-name"
                value={this.state.shirtTypeDisplay}
                options={this.state.displayTypesChoices}
                onChange={this.handleDropDownChanges}
                searchable={true}
                clearable={false}
            />
            : ''

        const sendButton = this.state.shirtTypeId !== '' && this.state.shirtTypeDisplay !== ''
            ? <Button>SEND</Button>
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("EnterShirtTypeToDisplay")
            ? <div>
                <h1>ADD SHIRT TYPE TO DISPLAY </h1>


                <Form size='large' onSubmit={this.sendShirtTypeToDisplay}>
                    <Segment stacked>
                        <label>Select Shirt Type</label> <br />
                        <label>{this.state.shirtTypeDisplay} || {this.state.shirtTypeId}</label>

                        <h5> SHIRT TYPE</h5>
                        {shirtTypeDropdown}

                        <h5> WHERE TO DISPLAY </h5>
                        {displayTypeDropdown}

                        {sendButton}

                        {/* <Button>SEND</Button> */}

                    </Segment>

                </Form>
            </div>
            : <h4>loading error a75</h4>

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>

                {wholeUI}


            </div>
        );
    }
}

export default EnterShirtTypeToDisplay;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ShirtTypes/EnterShirtTypeToDisplay.js